import { render, staticRenderFns } from "./CreateWaterPanel.vue?vue&type=template&id=483bc3da&scoped=true"
import script from "./CreateWaterPanel.vue?vue&type=script&lang=js"
export * from "./CreateWaterPanel.vue?vue&type=script&lang=js"
import style0 from "./CreateWaterPanel.vue?vue&type=style&index=0&id=483bc3da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483bc3da",
  null
  
)

export default component.exports